import Address from "@mapmycustomers/shared/types/Address";
import { RouteEndLocation, RouteStartLocation } from "@mapmycustomers/shared/types/entity/Route";
import { RouteEdgeEntity } from "@mapmycustomers/shared/types/entity/RouteDetail";
import { GeoPoint } from "@mapmycustomers/shared/types/shapes";

export interface EdgeLocationState {
  address?: Address;
  entity?: RouteEdgeEntity;
  geoPoint?: GeoPoint;
}

// Exactly-one-variant rule (BE spec): the entity wins when alive; otherwise the
// cached/manual address+geoPoint pair. A gone entity (binding kept in state but no
// live projection) intentionally falls through to the manual variant — the BE
// clears the broken binding on save.
export const buildStartLocationPayload = ({
  address,
  entity,
  geoPoint,
}: EdgeLocationState): RouteStartLocation | undefined => {
  if (entity) {
    return { startEntity: entity };
  }
  const addressString = address?.formattedAddress ?? address?.address;
  return addressString && geoPoint
    ? { startAddress: addressString, startGeoPoint: geoPoint }
    : undefined;
};

export const buildEndLocationPayload = ({
  address,
  entity,
  geoPoint,
}: EdgeLocationState): Partial<RouteEndLocation> => {
  if (entity) {
    return { endEntity: entity };
  }
  const addressString = address?.formattedAddress ?? address?.address;
  return addressString && geoPoint ? { endAddress: addressString, endGeoPoint: geoPoint } : {};
};
